
/**
 * HTML utilities - Migrated to secure implementations
 * 
 * IMPORTANT: This file has been migrated to use secure implementations.
 * All functions now directly export the secure versions from secureHtmlUtils.
 * 
 * For new code, import directly from './secureHtmlUtils' for better clarity.
 */

import { 
  secureHtmlSanitize, 
  secureDecodeHtmlEntities, 
  secureStripHtmlAndDecodeEntities 
} from './secureHtmlUtils';

/**
 * HTML sanitization with enhanced security
 * Now uses secure implementation - no deprecation warnings
 */
export const sanitizeHtml = (html: string): string => {
  return secureHtmlSanitize(html, 'BLOG_CONTENT');
};

/**
 * HTML entity decoding with enhanced security
 * Now uses secure implementation - no deprecation warnings
 */
export const decodeHtmlEntities = (text: string): string => {
  return secureDecodeHtmlEntities(text);
};

/**
 * Strip HTML and decode entities with enhanced security
 * Now uses secure implementation - no deprecation warnings
 */
export const stripHtmlAndDecodeEntities = (html: string): string => {
  return secureStripHtmlAndDecodeEntities(html);
};

// Re-export secure functions for direct access
export {
  secureHtmlSanitize,
  secureDecodeHtmlEntities,
  secureStripHtmlAndDecodeEntities
} from './secureHtmlUtils';
